/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ShareRevocation = zod.object({
  principalType: zod
    .enum(['USER', 'GROUP', 'GROUP_MEMBERS', 'PUBLIC'])
    .describe(
      'Who the grant is for: one person (USER), a group acting as itself (GROUP), everyone in a group (GROUP_MEMBERS), or everyone (PUBLIC).',
    ),
  principalUuid: zod.uuid().optional().describe('UUID v4 identifier'),
});

export type ShareRevocation = zod.input<typeof ShareRevocation>;
export type ShareRevocationOutput = zod.output<typeof ShareRevocation>;
